import {DropdownItem} from "../components/form/dropdown";

export const dataForMartialStatus: Array<DropdownItem> = [{name: "", value: ""}, {name: "Single", value: "S"}, {name: "Married", value: "M"}, {name: "Other", value: "O"}]
export const dataForGender: Array<DropdownItem> = [{name: "", value: ""}, {name: "Female", value: "F"}, {name: "Male", value: "M"}, {name: "Unknown", value: "U"}]

export const dataForRace: Array<DropdownItem> = [
    {name: "", value: ""},
    {
        cdcuid: "1002-5",
        raceCode: "R1",
        name: "American Indian Or Alaska Native",
        codeLevel: 1,
    },
    {
        cdcuid: "2028-9",
        raceCode: "R2",
        name: "Asian",
        codeLevel: 1,
    },
    {
        cdcuid: "2054-5",
        raceCode: "R3",
        name: "Black Or African American",
        codeLevel: 1,
    },
    {
        cdcuid: "2076-8",
        raceCode: "R4",
        name: "Native Hawaiian Or Other Pacific Islander",
        codeLevel: 1,
    },
    {
        cdcuid: "2106-3",
        raceCode: "R5",
        name: "White",
        codeLevel: 1,
    },
    {
        cdcuid: "2131-1",
        raceCode: "R9",
        name: "Other Race",
        codeLevel: 1,
    },
]
export const dataForEthnicity: Array<DropdownItem> = [
    {name: "", value: ""},
    {
        cdcuid: "2135-2",
        ethnicityCode: "E1",
        name: "Hispanic Or Latino",
    },
    {
        cdcuid: "2137-8",
        ethnicityCode: "E1.01",
        name: "Spaniard",
    },
    {
        cdcuid: "2138-6",
        ethnicityCode: "E1.01.001",
        name: "Andalusian",
    },
    {
        cdcuid: "2148-5",
        ethnicityCode: "E1.02",
        name: "Mexican",
    },
    {
        cdcuid: "2149-3",
        ethnicityCode: "E1.02.001",
        name: "Mexican American",
    },
    {
        cdcuid: "2155-0",
        ethnicityCode: "E1.03",
        name: "Central American",
    },
    {
        cdcuid: "2165-9",
        ethnicityCode: "E1.04",
        name: "South American",
    },
    {
        cdcuid: "2178-2",
        ethnicityCode: "E1.05",
        name: "Latin American",
    },
    {
        cdcuid: "2180-8",
        ethnicityCode: "E1.06",
        name: "Puerto Rican",
    },
    {
        cdcuid: "2182-4",
        ethnicityCode: "E1.07",
        name: "Cuban",
    },
    {
        cdcuid: "2184-0",
        ethnicityCode: "E1.08",
        name: "Dominican",
    },
    {
        cdcuid: "2186-5",
        ethnicityCode: "E2",
        name: "Not Hispanic Or Latino",
    },
]

export const dataForPreferenceLanguage: Array<DropdownItem> = [{name: "", value: ""}, {name: "English", value: "en"}, {name: "Chinese", value: "zh"}, {name: "Chinese-Traditional", value: "zh-hk"}, {name: "Spanish", value: "es"}, {name: "Korea", value: "ko"}]
export const dataForNotificationPreference: Array<DropdownItem> = [{name: "", value: ""}, {name: "Email", value: 4}, {name: "SMS", value: 5}, {name: "Phone", value: 1}, {name: "Mail", value: 2}, {name: "Fax", value: 3}]
export const dataForState: Array<DropdownItem> = [
    {name: "", value: ""},
    {name: "Alabama", value: "AL"},
    {name: "Alaska", value: "CA"},
    {name: "Arizona", value: "AZ"},
    {name: "Arkansas", value: "AR"},
    {name: "California", value: "CA"},
    {name: "Canal Zone", value: "CZ"},
    {name: "Colorado", value: "CO"},
    {name: "Connecticut", value: "CT"},
    {name: "District of Columbia", value: "DC"},
    {name: "Florida", value: "FL"},
    {name: "Georgia", value: "GA"},
    {name: "Guam", value: "CA"},
    {name: "Hawaii", value: "GU"},
    {name: "Idaho", value: "ID"},
    {name: "Illinois", value: "IN"},
    {name: "Indiana", value: "CA"},
    {name: "Iowa", value: "IA"},
    {name: "Kansas", value: "KS"},
    {name: "Kentucky", value: "KY"},
    {name: "Louisiana", value: "LA"},
    {name: "Maine", value: "ME"},
    {name: "Maryland", value: "MD"},
    {name: "Massachusetts", value: "MA"},
    {name: "Michigan", value: "MI"},
    {name: "Minnesota", value: "MN"},
    {name: "Mississippi", value: "MS"},
    {name: "Montana", value: "MT"},
    {name: "Nebraska", value: "NE"},
    {name: "Nevada", value: "NV"},
    {name: "New Hampshire", value: "NH"},
    {name: "New Jersey", value: "NJ"},
    {name: "New Mexico", value: "NM"},
    {name: "New York", value: "NY"},
    {name: "North Carolina", value: "NC"},
    {name: "North Dakota", value: "ND"},
    {name: "Ohio", value: "OH"},
    {name: "Oklahoma", value: "OK"},
    {name: "Oregon", value: "OR"},
    {name: "Pennsylvania", value: "PA"},
    {name: "Puerto Rico", value: "PR"},
    {name: "Rhode Island", value: "RI"},
    {name: "South Carolina", value: "SC"},
    {name: "South Dakota", value: "SD"},
    {name: "Tennessee", value: "TX"},
    {name: "Texas", value: "TX"},
    {name: "Utah", value: "YT"},
    {name: "Vermont", value: "VT"},
    {name: "Virgin Islands", value: "VI"},
    {name: "Virginia", value: "VA"},
    {name: "Washington", value: "WA"},
    {name: "West Virginia", value: "WV"},
    {name: "Wisconsin", value: "WI"},
    {name: "Wyoming", value: "WY"},

]

export interface ConsentFormItem {
    title: string,
    checkedContent: string,
    checked: boolean,
    open: boolean,
}

export const dataForConsentForms: Array<ConsentFormItem> = [
    {title: "Healthix Access to Patient Information", open: true,
        checked: false,
        checkedContent: "I give consent for ClinicName to access all of my electronic health information through Healthix to provide health care."},
    {title: "Patient Agreement", open: false, checked: false, checkedContent: "I accept the patient agreement."},
]

export interface MedicalHistoryItem {
    checked: boolean,
    name: string,
    value: string,
    [x: string]: any,
}

export interface MedicalHistorySection {
    title: string,
    data: Array<MedicalHistoryItem>
}

export const dataForMedicalHistory: Array<MedicalHistorySection> = [
    {title: "List of your past medical consitions:",
        data: [
            {
                checked: false,
                name: "Hypertension",
                value: "",
            },
            {
                checked: false,
                name: "Diabetes",
                value: "",
            },
        ],
    },
    {title: "Heart diseases::",
        data: [
            {
                checked: false,
                name: "Coronary Artery Disease",
                value: "",
            },
            {
                checked: false,
                name: "Silent Ischemia",
                value: "",
            },
            {
                checked: false,
                name: "Angina",
                value: "",
            },
            {
                checked: false,
                name: "Heart Attack (Myocardial Infarction)",
                value: "",
            },
            {
                checked: false,
                name: "Heart Failure",
                value: "",
            },
            {
                checked: false,
                name: "Arrhythmia",
                value: "",
            },
            {
                checked: false,
                name: "Heart Defects",
                value: "",
            },
            {
                checked: false,
                name: "Aortic Aneurysms",
                value: "",
            },
            {
                checked: false,
                name: "Peripheral Arterial Disease",
                value: "",
            },
            {
                checked: false,
                name: "Other heart diseases",
                value: "",
            },
            {
                checked: false,
                name: "Strokes",
                value: "",
            },
        ],
    },
    {title: "Liver diseases:",
        data: [
            {
                checked: false,
                name: "Hepatitis A",
                value: "",
            },
            {
                checked: false,
                name: "Hepatitis B",
                value: "",
            },
            {
                checked: false,
                name: "Hepatitis C",
                value: "",
            },
            {
                checked: false,
                name: "Fatty Liver",
                value: "",
            },
            {
                checked: false,
                name: "Congenital Hepatitis",
                value: "",
            },
            {
                checked: false,
                name: "Cyst of Liver",
                value: "",
            },
            {
                checked: false,
                name: "Metabolic Cirrhosis",
                value: "",
            },
            {
                checked: false,
                name: "Other liver disases",
                value: "",
            },
        ],
    },
    {title: "Kidney diseases:",
        data: [
            {
                checked: false,
                name: "Polycystic Kidney Disease",
                value: "",
            },
            {
                checked: false,
                name: "Hypertensive Nephrosclerosis",
                value: "",
            },
            {
                checked: false,
                name: "Glomerulonephritis/Glomerulosclerosis",
                value: "",
            },
            {
                checked: false,
                name: "Urinary Tract Infection",
                value: "",
            },
            {
                checked: false,
                name: "Kidney Stones",
                value: "",
            },
            {
                checked: false,
                name: "Diabetic Kidney Disease",
                value: "",
            },
            {
                checked: false,
                name: "Analogesic Nephropathy",
                value: "",
            },
            {
                checked: false,
                name: "Other",
                value: "",
            },
        ],
    },
    {title: "Cancer(s):",
        data: [
            {
                checked: false,
                name: "Breast Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Colorectal Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Lung Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Prostate Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Gastric Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Pancreatic Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Liver Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Other Cancer",
                value: "",
            },
        ],
    },
    {title: "Please list any cancer(s) in your family",
        data: [
            {
                checked: false,
                name: "Breast Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Colorectal Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Lung Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Prostate Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Gastric Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Pancreatic Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Liver Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Skin Cancer",
                value: "",
            },
            {
                checked: false,
                name: "Other Cancer",
                value: "",
            },
        ],
    },
    {title: "Please list your past surgeries",
        data: [
            {
                checked: false,
                name: "None",
                value: "",
            },
        ],
    },
    {title: "Are you allergic to any medications?",
        data: [
            {
                checked: false,
                name: "None",
                value: "",
            },
        ],
    },
]

export const dataForCurringIllness: Array<MedicalHistorySection> = [
    {title: "Do you have any of the following?",
        data: [
            {
                checked: false,
                name: "Fever/Chills",
                value: "",
            },
            {
                checked: false,
                name: "Night sweats",
                value: "",
            },
            {
                checked: false,
                name: "Unexpected weight loss",
                value: "",
            },
            {
                checked: false,
                name: "Shortness of breath",
                value: "",
            },
            {
                checked: false,
                name: "Chest pain",
                value: "",
            },
            {
                checked: false,
                name: "Nausea",
                value: "",
            },
            {
                checked: false,
                name: "Vomiting",
                value: "",
            },
            {
                checked: false,
                name: "Diarrhea",
                value: "",
            },
            {
                checked: false,
                name: "Constipation",
                value: "",
            },
            {
                checked: false,
                name: "Leg/arm weakness",
                value: "",
            },
            {
                checked: false,
                name: "New bony pain",
                value: "",
            },
            {
                checked: false,
                name: "Other complaints",
                value: "",
            },
        ],
    },
]

export const dataForScreening: Array<MedicalHistorySection> = [
    {title: "Have you ever had sigmoidoscopy or colonoscopy?",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                valueYear: "",
                valueDoctorName: "",
                valueDoctorPhoneNumber: "",
            },
        ],
    },
    {title: "Last mammogram",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                valueYear: "",
                valueDoctorName: "",
                valueDoctorPhoneNumber: "",
            },
        ],
    },
    {title: "Last PAP Smear",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Please provide history of last PSA screening",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Are you an ex-smoker?",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Are you a current smoker?",
        data: [
            {
                checked: false,
                name: "No",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Yes",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Over the past 2 weeks, have you been bothered by:",
        data: [
            {
                checked: false,
                name: "Little interest or pleasure in doing things",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Feeling down, depressed, or hopeless",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Are you:",
        data: [
            {
                checked: false,
                name: "Drinking alcohol daily",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Drinking as an eye opener",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "None of above",
                value: "",
                checkedOnly: true,
            },
        ],
    },
    {title: "Do you have any exposure to hazardous materials:",
        data: [
            {
                checked: false,
                name: "Oil-based paints",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Paints, inks and coatings with heavy metal pigments",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Flourescent light bulbs and ballasts",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Degreasing solvents",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Chlorinated solvents",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Lead-acid vehicle batteries",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Pesticides",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Cleaning products",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Vehicle fluids: spent antifreeze, engine oil, hydraulic oil, brake cleaners",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Electronic wastes: computer monitors",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Metal wastes: lead, mercury, copper, zinc",
                value: "",
                checkedOnly: true,
            },
            {
                checked: false,
                name: "Other",
                value: "",
                checkedOnly: true,
            },
        ],
    },
]
